import { v4 as uuidv4 } from 'uuid';
import {
  addCommentToEntity,
  deleteComment,
  deleteCommentThread,
  updateComment,
} from 'features/comments/commentService';
import {
  loadCommentsThunk,
  setActiveThreadId,
  setOpenNewCommentThread,
} from 'features/comments/commentsSlice';

export const formatComment = ({
  data,
  commentId = uuidv4(),
  projectId,
  entityType,
  entityId,
  entityVersion,
  authorId,
  shareWithAll = false,
  createdAt = new Date(),
}) => ({
  ...data,
  commentId,
  projectId,
  entityType,
  entityId,
  entityVersion,
  authorId,
  shareWithAll,
  createdAt,
});

export const getCommentsRepositoryPluginAdapter = (
  projectId,
  currentUser,
  comments,
  entityType,
  entityId,
  entityVersion,
  commentThreads,
  dispatch,
  formatThread,
  isEntitySharedWithClient
) => ({
  async addComment(data, format = formatComment) {
    const foundComment = comments.find((_) => data.commentId === _.commentId);

    dispatch(setOpenNewCommentThread(false));

    if (foundComment) return Promise.resolve(foundComment);

    const shareWithAll = isEntitySharedWithClient;

    const threadVersion = entityVersion;

    const comment = format({
      data,
      projectId,
      entityType,
      entityId,
      entityVersion: threadVersion,
      authorId: currentUser.id,
      shareWithAll,
    });

    await dispatch(addCommentToEntity(comment));

    dispatch(
      loadCommentsThunk(
        projectId,
        entityType,
        entityId,
        entityVersion,
        isEntitySharedWithClient
      )
    );

    return Promise.resolve();
  },

  updateComment(data) {
    const foundComment =
      comments.find((_) => data.commentId === _.commentId) || {};
    const updatedComment = { ...foundComment, ...data };

    return updateComment(updatedComment);
  },

  async removeComment(data) {
    const foundThread = commentThreads.find((_) => data.threadId === _.id);

    if (foundThread && foundThread.comments[0].commentId === data.commentId) {
      await dispatch(
        deleteCommentThread({
          threadId: data.threadId,
          projectId,
          entityType,
          entityId,
        })
      );
    } else {
      await deleteComment({
        threadId: data.threadId,
        projectId,
        entityType,
        entityId,
        commentId: data.commentId,
      });
    }

    dispatch(setActiveThreadId(''));

    dispatch(
      loadCommentsThunk(
        projectId,
        entityType,
        entityId,
        entityVersion,
        isEntitySharedWithClient
      )
    );

    return Promise.resolve();
  },

  getCommentThread(data) {
    const foundThread = commentThreads.find(
      (thread) => thread.id === data.threadId || thread.id === data.id
    );

    return Promise.resolve(foundThread ? formatThread(foundThread) : undefined);
  },
});
